export const INFRASTRUCTURE_MF_NAME = 'map-search-frontend';

export const MORTGAGE_CALCULATOR_MF_NAME = 'mortgage-calculator-micro-frontend';

export const AD_BANNER_MF_NAME = 'ad-banner-frontend';
